import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { translations } from "./translations";

const settings = {
  lng: "en",
  fallbackLng: "en",
  debug: false,

  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
  resources: translations,
};

i18n.use(LanguageDetector).use(initReactI18next).init(settings);

export default i18n;
